import { sheetsEndpoint } from '../data/integrations';
import { ScoringResult } from '../types/lead';

export interface ScoringRequest {
  codigo_publico: string;
  cuil: string;
  telefono: string;
  email: string;
  consentimiento: 'SI';
  fecha_consentimiento: string;
}

export type ScoringResponse = { ok: true; result: ScoringResult } | { ok: false; code: 'INVALID' | 'RATE' | 'NETWORK'; error: string };

export const newScoringCode = () => `VC-${Math.random().toString(36).slice(2, 10).toUpperCase().padEnd(8, '0')}`;

export const scoringLabels: Record<ScoringResult, string> = {
  PRE_APROBADO: 'PRE APROBADO',
  MOROSIDAD_ACTIVA: 'MOROSIDAD ACTIVA',
  RECHAZADO: 'RECHAZADO',
  PENDIENTE: 'EN REVISIÓN',
};

/**
 * Consulta el scoring en el Apps Script (que a su vez consulta la Central de Deudores del BCRA).
 * La página sólo recibe la categoría; el detalle completo queda en la planilla y en el email interno.
 */
export async function requestScoring(data: ScoringRequest): Promise<ScoringResponse> {
  const ctrl = new AbortController();
  const timer = window.setTimeout(() => ctrl.abort(), 45000);
  try {
    const res = await fetch(sheetsEndpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ action: 'okm.scoring', data }),
      redirect: 'follow',
      signal: ctrl.signal,
    });
    const json = (await res.json()) as { ok?: boolean; code?: string; error?: string; resultado?: string };
    if (json.ok) {
      const r = json.resultado as ScoringResult;
      return { ok: true, result: r in scoringLabels ? r : 'PENDIENTE' };
    }
    if (json.code === 'RATE') return { ok: false, code: 'RATE', error: 'Ya hiciste varias consultas. Probá de nuevo más tarde.' };
    if (json.code === 'INVALID') return { ok: false, code: 'INVALID', error: json.error || 'Revisá los datos ingresados.' };
    return { ok: false, code: 'NETWORK', error: json.error || 'No pudimos completar la consulta.' };
  } catch {
    return { ok: false, code: 'NETWORK', error: 'No pudimos conectarnos. Revisá tu conexión.' };
  } finally {
    window.clearTimeout(timer);
  }
}
